module.exports = __webpack_public_path__ + "static/media/emptycart.c0efb84c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cart/emptycart.png
// module id = 633
// module chunks = 0